module.exports = __webpack_public_path__ + "img/about-bg.4b900f60.png";